// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__LD1BF","close-x":"Tag_close-x__07be4","tag-content":"Tag_tag-content__nGJ4S"};